// 301 redirect map for the Wix → Lovable migration of travelbackland.com.
// Only paths that DIFFER between old and new site need an entry here.
// Wix paths that already match a route on the new site (e.g. /glamping-wedding-venue)
// resolve normally and don't need a redirect.
//
// Add ambiguous mappings here as the team confirms intended targets.

export const WIX_REDIRECTS: Record<string, string> = {
  // Blog posts: Wix used /post/<slug>, new site uses /blog/<slug>.
  // Handled programmatically in resolveWixRedirect() — not listed individually.

  // Legal
  "/terms-and-conditions": "/terms",
  "/affiliate-program-policies": "/terms",

  // Category pages — these now exist as real SSR routes, no redirect needed.
  // Listed here as comments so future maintainers don't re-add redirects:
  //   /culinary                          → real route
  //   /luxury-tented-lodging             → real route

  "/tentcomparison": "/luxury-tented-lodging",

  // Lodging (legacy Wix paths)
  "/lodging": "/luxury-tented-lodging",
  "/luxury-lodging-camping": "/luxury-tented-lodging",
  "/general-5": "/luxury-tented-lodging",

  // Things-to-do — old Wix activities page now split into onsite/nearby
  "/glamping-activities-and-amenities": "/onsite-experiences",
  "/amenities-activities": "/onsite-experiences", // legacy Wix path
  "/explore-arizona-grand-canyon-area": "/nearby-experiences",
  "/explore-arizona": "/nearby-experiences",      // legacy Wix path
  "/explore-1": "/nearby-experiences",            // legacy Wix path

  // Events (legacy Wix paths)
  "/events": "/outdoor-glamping-events",
  "/events-weddings-retreats": "/outdoor-glamping-events",
  "/events-landing-page": "/glamping-for-large-groups",
  "/events-sub-landing-page": "/glamping-family-reunions",
  "/corporate-glamping-retreats": "/luxury-corporate-retreats",

  // Logistics / location pages → consolidated getting-here page
  "/backland-location": "/getting-here",
  
  "/location": "/getting-here",            // legacy Wix path
  "/grand-canyon-resort": "/getting-here", // legacy Wix path

  // Brand / about → home
  "/about-backland-eco-resort": "/",
  "/about": "/", // legacy Wix path
  "/positive-impact": "/",
  "/stay-for-good": "/",
  "/land-image-gallery": "/",

  // Seasonal landing pages → home
  "/valentine-s-getaway": "/",
  "/mother-s-day": "/",
  "/north-pole-backland": "/",

  // Menus → culinary page (menus live inside it)
  "/menu": "/culinary",
  "/lunch-menu": "/culinary",

  // Booking & contact
  "/contact": "/info",
  "/book-now": "/",
  "/activity-booking": "/enhance",

  // Offers (old per-offer paths → new combined landing)
  "/couples-offer": "/offers",
  "/family-offer": "/offers",
};

/**
 * Resolve a Wix path to a new-site path.
 * Returns the destination path if a redirect applies, otherwise null.
 * Handles the /post/<slug> → /blog/<slug> rewrite generically.
 */
export function resolveWixRedirect(pathname: string): string | null {
  // Normalize: strip trailing slash (except root) for matching.
  const path = pathname !== "/" && pathname.endsWith("/")
    ? pathname.slice(0, -1)
    : pathname;

  // /post/<slug> → /blog/<slug>
  if (path.startsWith("/post/")) {
    const slug = path.slice("/post/".length);
    if (slug) return `/blog/${slug}`;
  }

  const direct = WIX_REDIRECTS[path];
  if (direct) return direct;

  return null;
}
